import ImageBasic from "../Common/Image/ImageBasic";
import IMG from "../../constants/image";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {PATH} from "../../constants";
import {text} from "../../constants/text";
import React, {useEffect, useMemo, useState} from "react";
import {isMobile as deviceDetectIsMobile} from "react-device-detect";
import IconSvg from "../IconSvg/IconSvg";
import notificationStore from "../../store/notificationStore";
import appStore from "../../store/appStore";
import {clsx} from "clsx";
import {ENV} from "../../network/config";
import popupStore from "../../store/popupStore";
import PopupReadNoti from "../Notification/PopupReadNoti";

const dataTitle = [
  {
    id: "quan-ly-san-pham",
    title: text.managementProduct,
    url: PATH.MANAGING_PRODUCT,
  },
  {
    id: "thong-tin-cua-hang",
    title: text.infoStore,
    url: PATH.STORE_INFO,
  },
  {
    id: "quan-ly-tai-khoan",
    title: text.account,
    url: PATH.ACCOUNT_SETTING,
  },
  {
    id: "doi-mat-khau",
    title: text.changePassword,
    url: PATH.CHANGE_PASSWORD,
  },
  {
    id: "quan-ly-don-hang",
    title: text.orderManagement,
    url: PATH.MANAGING_ORDER,
  },
  {
    id: "quan-ly-don-hang/order",
    title: text.detailOrders,
    url: PATH.BUYER_MANAGEMENT_CART_DETAIL,
  },
  {
    id: "chia-se",
    title: text.share,
    url: PATH.SHARE,
  },
  {
    id: "so-dia-chi",
    title: text.numberAddress,
    sub: [
      {id: 'edit', title: text.editAddress},
      {id: 'add', title: text.addAddress}
    ],
    url: PATH.ADDRESS,
  },
  {
    id: "tao-san-pham",
    title: text.createProduct,
    url: PATH.CREATE_PRODUCT,
  },
  {
    id: "thong-bao",
    title: text.notification,
    url: PATH.NOTIFICATION,
  },
  {
    id: "cau-hinh-van-chuyen",
    title: text.shippingConfig,
    url: PATH.SHIPPING_CONFIG,
  },
];

export default function HeaderHome() {
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const searchIdAddress = searchParams.get('id')
  const searchEdit = searchParams.get('edit')
  const searchAdd = searchParams.get('add')
  const {countNoti} = notificationStore();
  const {fromNativeApp} = appStore();
  const {setPopupMobile} = popupStore() || {}

  const [isMobile, setIsMobile] = useState(false);
  const onHandleNavigation = () => {
    navigate(-1);
  };

  const subTitle = useMemo(() => {
    if (isMobile && pathname) {
      const currentPage = dataTitle.find((item) => item?.url === pathname);
      if (currentPage && currentPage.sub) {
        if (searchEdit || searchIdAddress) {
          return currentPage.sub.filter(sub => sub.id === 'edit');
        }
        if (searchAdd) {
          return currentPage.sub.filter(sub => sub.id === 'add');
        }
      }
    }
    return [];
  }, [pathname, isMobile, searchEdit, searchAdd, searchIdAddress]);

  const title = useMemo(() => {
    if (isMobile && pathname) {
      const currentPage = dataTitle.find((item) => item?.url === pathname);
      if (currentPage) {
        if (subTitle.length > 0) {
          return [{...currentPage, title: subTitle[0].title}];
        }
        return [currentPage];
      }
    }
    return [];
  }, [pathname, isMobile, subTitle]);

  const handleDialogNotification = () => {
    setPopupMobile({
      isOpenMobile: true,
      data: {
        height: 'h-[30%]',
        top: 'top-[74%]',
        children: <PopupReadNoti
          onClosePopup={setPopupMobile({})}
        />
      }
    });
  }
  // Simplified mobile detection
  useEffect(() => {
    setIsMobile(deviceDetectIsMobile);
  }, []);

  if (pathname === PATH.HOME)
    return (
      <div className={clsx("relative z-10 flex justify-between w-full p-4 text-white",
        fromNativeApp ? 'h-[110px] items-end' : 'h-[80px] items-center ',
      )}>
        <Link to={`${ENV.FUNONG_DOMAIN}/buyer`} aria-label="Home">
          <ImageBasic
            className="w-7"
            src={IMG.icon.chevronLefLight}
          />
        </Link>
        <div className={clsx(fromNativeApp && 'pb-1', "text-sm font-bold")}>{'Cửa hàng của tôi'}</div>
        <div className="relative text-center flex flex-col items-center">
          <div className="flex justify-center items-center p-1 gap-2.5 rounded-full bg-white bg-opacity-80">
            <Link to={PATH.NOTIFICATION}>
              <IconSvg iconName="bell" size={24} color={"#197D55"}/>
            </Link>
          </div>
          {countNoti?.total > 0 && (
            <div
              className="absolute -top-1 -right-3 bg-red text-white text-[10px] font-bold rounded-full w-6 h-4 flex items-center justify-center">
              {countNoti?.total > 99 ? "99+" : countNoti?.total}
            </div>
          )}
        </div>
      </div>
    );
  return (
    <div className={clsx("relative z-10 flex justify-between w-full text-white p-4",
      fromNativeApp ? 'h-[110px] items-end' : 'items-center h-[80px]',
    )}>
      <ImageBasic
        className="w-7"
        src={IMG.icon.chevronLefLight}
        onClick={onHandleNavigation}
      />
      <div className={clsx(!fromNativeApp && 'pb-1', "text-sm font-bold")}>{title?.[0]?.title}</div>
      {(pathname === PATH.NOTIFICATION && (
        <div onClick={handleDialogNotification}>
          <IconSvg iconName="mark-1" color="#fff" size={24}/>
        </div>
      )) || <div></div>}
    </div>
  );
}
